<div class="box_style_2 hidden-xs" id="help">
  <h4><span>Bestellung oder Fragen?</span></h4>
  <p>Montag bis Freitag<br>9:00Uhr - 12:00Uhr</p>
  <a href="tel://004366475044327" class="phone">+43 664 750 44 327</a>
  <br>
  <p>Bitte als Mailbox, Whatsapp oder SMS Nachricht, <br>wir rufen zurück!</p>
</div>
